import React from 'react';
import { Typography } from '@mui/material';
import ComparisonBadge from './ComparisonBadge';
import type { ComparisonMeaning } from './label.types';

interface DeltaComparisonBadgeProps {
  value: number | null | undefined;
  meaning: ComparisonMeaning;
  size?: 'small' | 'medium';
}

/** 퍼센트 증감(▲/▼) — DailyReport·KPI 인라인용 */
const DeltaComparisonBadge: React.FC<DeltaComparisonBadgeProps> = ({
  value,
  meaning,
  size = 'small'
}) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return (
      <Typography component="span" variant="inherit" color="text.secondary">
        —
      </Typography>
    );
  }

  const direction = value > 0 ? 'up' : value < 0 ? 'down' : 'flat';
  const sign = value > 0 ? '▲' : value < 0 ? '▼' : '■';
  const dirLabel = value > 0 ? '상승' : value < 0 ? '하락' : '';
  const label = `${sign} ${Math.abs(value).toFixed(1)}%${dirLabel ? ` ${dirLabel}` : ''}`;

  return (
    <ComparisonBadge
      value={Math.abs(value)}
      direction={direction}
      meaning={meaning}
      label={label}
      size={size}
    />
  );
};

export default DeltaComparisonBadge;
